const ERROR_MESSAGES = {
  PASSWORD_LENGTH: 'Password must be at least 8 characters long'
} as const;

export default ERROR_MESSAGES;
